import axios from "axios"

const state = {
  STATUS: null,
  API_ROUTE: "/devices",
  devicesList: [],
  totalDevices: 0
}

const getters = {
  devicesList: (state) => state.devicesList,
  totalDevices: (state) => state.totalDevices
}

const mutations = {
  setDevices(state, devices) {
    state.devicesList = devices
  },
  setTotalDevices(state, total) {
    state.totalDevices = total
  }
}

const actions = {
  async listDevices({ commit }) {
    try {
      const userId = sessionStorage.getItem("userID")
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${userId}`
      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      // const response = await axios.get(url, config)
      const response = {data: [
        {
          "id": "62fbcd4e-8669-11ec-966c-f8cab8545736",
          "name": "0-000",
          "serialNo": null,
          "deviceType": "Admin",
          "description": null,
          "status": "Leased",
          "locations": [
            {
              "id": "4adae133-f189-4bd1-881b-37321c6903e8",
              "orgID": "ab35a904-6be4-49b9-b163-4d470c4c5785",
              "activationDate": "11/4/2022 12:00:00 AM",
              "lastActiveDate": "11/18/2022 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "test",
                "address": {
                  "id": null,
                  "address1": "test",
                  "address2": "",
                  "state": "283",
                  "city": "qws",
                  "country": "12",
                  "zipCode": "90012",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "63005894-8669-11ec-966c-f8cab8545736",
          "name": "1-001",
          "serialNo": null,
          "deviceType": "Generation 1",
          "description": null,
          "status": "Inactive",
          "locations": [
            {
              "id": "84a4b761-8448-4673-aed6-fb1399499b4f",
              "orgID": "ab35a904-6be4-49b9-b163-4d470c4c5785",
              "activationDate": "11/2/2022 12:00:00 AM",
              "lastActiveDate": "11/30/2022 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "florida",
                "address": {
                  "id": null,
                  "address1": "asf",
                  "address2": "",
                  "state": "282",
                  "city": "Coimbatore",
                  "country": "12",
                  "zipCode": "90012",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            },
            {
              "id": "23fc532f-48f0-4618-9d30-3053b32a4544",
              "orgID": "ab35a904-6be4-49b9-b163-4d470c4c5785",
              "activationDate": "2/18/2022 12:00:00 AM",
              "lastActiveDate": "2/28/2022 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "LocationOne",
                "address": {
                  "id": null,
                  "address1": "Selakkarachal PO, Sulur TK, Coimbatore",
                  "address2": "",
                  "state": "291",
                  "city": "Coimbatore",
                  "country": "12",
                  "zipCode": "90012",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "63062bc1-8669-11ec-966c-f8cab8545736",
          "name": "2-001",
          "serialNo": null,
          "deviceType": "Generation 2",
          "description": null,
          "status": "",
          "locations": []
        },
        {
          "id": "630a6cbe-8669-11ec-966c-f8cab8545736",
          "name": "2-002",
          "serialNo": null,
          "deviceType": "Generation 2",
          "description": null,
          "status": "Owned",
          "locations": [
            {
              "id": "92c64e83-cc48-4420-9788-534c1db55b5d",
              "orgID": "50e90306-c246-45f5-b7cb-88f74baab2f8",
              "activationDate": "11/9/2022 12:00:00 AM",
              "lastActiveDate": "12/9/2025 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "IRCHD",
                "address": {
                  "id": null,
                  "address1": "1705 19th Pl Suite G3",
                  "address2": "",
                  "state": "291",
                  "city": "Vero Beach",
                  "country": "12",
                  "zipCode": "32960",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "68144989-8669-11ec-966c-f8cab8545736",
          "name": "3-000",
          "serialNo": null,
          "deviceType": null,
          "description": null,
          "status": "",
          "locations": []
        },
        {
          "id": "630d83a9-8669-11ec-966c-f8cab8545736",
          "name": "3-001",
          "serialNo": null,
          "deviceType": "Generation 3",
          "description": null,
          "status": "",
          "locations": []
        },
        {
          "id": "68144be6-8669-11ec-966c-f8cab8545736",
          "name": "3-402-Braves",
          "serialNo": "3-402",
          "deviceType": null,
          "description": "Braves",
          "status": "Owned",
          "locations": [
            {
              "id": "67ad4bc1-b15f-42b1-b314-0d11f40e022c",
              "orgID": "b990b0c9-ae6c-4981-8690-e48798e4ee89",
              "activationDate": "3/25/2022 12:00:00 AM",
              "lastActiveDate": "3/28/2024 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "CoolTodayPark-3-402",
                "address": {
                  "id": null,
                  "address1": "18800 W Villages Pkwy",
                  "address2": "",
                  "state": "291",
                  "city": "Venice",
                  "country": "12",
                  "zipCode": "34293",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "68146787-8669-11ec-966c-f8cab8545736",
          "name": "3-403",
          "serialNo": null,
          "deviceType": null,
          "description": null,
          "status": "",
          "locations": []
        },
        {
          "id": "681467b2-8669-11ec-966c-f8cab8545736",
          "name": "3-404",
          "serialNo": null,
          "deviceType": null,
          "description": null,
          "status": "",
          "locations": []
        },
        {
          "id": "6814a359-8669-11ec-966c-f8cab8545736",
          "name": "3-405",
          "serialNo": null,
          "deviceType": null,
          "description": null,
          "status": "",
          "locations": []
        },
        {
          "id": "6815163d-8669-11ec-966c-f8cab8545736",
          "name": "3-406",
          "serialNo": null,
          "deviceType": null,
          "description": null,
          "status": "",
          "locations": []
        },
        {
          "id": "68153ecd-8669-11ec-966c-f8cab8545736",
          "name": "3-407",
          "serialNo": null,
          "deviceType": null,
          "description": null,
          "status": "",
          "locations": []
        },
        {
          "id": "681549aa-8669-11ec-966c-f8cab8545736",
          "name": "3-408",
          "serialNo": null,
          "deviceType": null,
          "description": null,
          "status": "Leased",
          "locations": [
            {
              "id": "68aa80e2-8da2-4478-b01f-e7ef72091a9a",
              "orgID": "ab35a904-6be4-49b9-b163-4d470c4c5785",
              "activationDate": "11/3/2022 12:00:00 AM",
              "lastActiveDate": "9/15/2023 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "test_location",
                "address": {
                  "id": null,
                  "address1": "Selakkara",
                  "address2": "",
                  "state": "284",
                  "city": "Coimbatore",
                  "country": "12",
                  "zipCode": "90012",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "68154b6a-8669-11ec-966c-f8cab8545736",
          "name": "3-409-Braves",
          "serialNo": "3-409",
          "deviceType": null,
          "description": "Braves",
          "status": "Owned",
          "locations": [
            {
              "id": "a5aead2f-5ad5-442f-bc15-1eaf513b36b9",
              "orgID": "b990b0c9-ae6c-4981-8690-e48798e4ee89",
              "activationDate": "3/25/2022 12:00:00 AM",
              "lastActiveDate": "3/28/2025 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "CoolTodayPark-3-409",
                "address": {
                  "id": null,
                  "address1": "18800 W Villages Pkwy",
                  "address2": "",
                  "state": "291",
                  "city": "Venice",
                  "country": "12",
                  "zipCode": "34293",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "68154b99-8669-11ec-966c-f8cab8545736",
          "name": "3-40X",
          "serialNo": null,
          "deviceType": null,
          "description": null,
          "status": "Inactive",
          "locations": [
            {
              "id": "3dbbc70d-88b5-490f-bc65-33697e69b2b7",
              "orgID": "ab35a904-6be4-49b9-b163-4d470c4c5785",
              "activationDate": "11/3/2022 12:00:00 AM",
              "lastActiveDate": "11/3/2022 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "test2",
                "address": {
                  "id": null,
                  "address1": "Selakkarachal PO, Sulur TK, Coimbatore",
                  "address2": "",
                  "state": "284",
                  "city": "Coimbatore",
                  "country": "12",
                  "zipCode": "64165-8",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            },
            {
              "id": "a99a4b55-ac55-4c42-98a4-c56aedd69b15",
              "orgID": "ab35a904-6be4-49b9-b163-4d470c4c5785",
              "activationDate": "11/11/2022 12:00:00 AM",
              "lastActiveDate": "11/16/2022 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "test2",
                "address": {
                  "id": null,
                  "address1": "add",
                  "address2": "",
                  "state": "283",
                  "city": "fl",
                  "country": "",
                  "zipCode": "90012",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "68154db2-8669-11ec-966c-f8cab8545736",
          "name": "3-410",
          "serialNo": null,
          "deviceType": null,
          "description": null,
          "status": "",
          "locations": []
        },
        {
          "id": "96258162-1538-4d4b-bf64-d708cb89c157",
          "name": "37-402-1",
          "serialNo": "caec-37-402-1",
          "deviceType": null,
          "description": "Caec-37-402-1",
          "status": "Owned",
          "locations": [
            {
              "id": "5698ac2e-72fb-4399-ab8e-8e4459013d8e",
              "orgID": "3e82aaf6-3237-4754-9238-c360a365a5a4",
              "activationDate": "10/11/2022 12:00:00 AM",
              "lastActiveDate": "6/10/2025 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "Headquarters-37-402-1",
                "address": {
                  "id": null,
                  "address1": "Florida",
                  "address2": "",
                  "state": "291",
                  "city": "FL",
                  "country": "12",
                  "zipCode": "90012",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "cafa5866-f6cc-4da1-8774-7ad7d817a321",
          "name": "37-402-2",
          "serialNo": "37-402-2",
          "deviceType": null,
          "description": "Caec-37-402-2",
          "status": "Owned",
          "locations": [
            {
              "id": "98a2fdea-8286-4b14-ad82-5e61d861c1c2",
              "orgID": "2fc43627-fb5d-4fd1-9a73-d4873425ff92",
              "activationDate": "10/10/2022 12:00:00 AM",
              "lastActiveDate": "6/17/2025 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "HQ-37-402-2",
                "address": {
                  "id": null,
                  "address1": "3500 US HWY1",
                  "address2": "",
                  "state": "291",
                  "city": "vero beach",
                  "country": "12",
                  "zipCode": "32960",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "e70ebd97-2375-43bd-b72a-c45f95c515e6",
          "name": "37-402-ELC",
          "serialNo": "37-402",
          "deviceType": null,
          "description": "ELC",
          "status": "Leased",
          "locations": [
            {
              "id": "53e7025f-18c2-4db6-aab4-af5a2ad30ebe",
              "orgID": "4db67cf3-bb59-4854-b153-4b34b637b38a",
              "activationDate": "12/1/2022 12:00:00 AM",
              "lastActiveDate": "12/1/2025 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "ELC",
                "address": {
                  "id": null,
                  "address1": "350 Printers Pkwy",
                  "address2": "",
                  "state": "287",
                  "city": "Colorado Springs",
                  "country": "12",
                  "zipCode": "80910",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "16d4b0ab-3780-465f-9ef9-131ca9cdaa38",
          "name": "37-402-IRCHD",
          "serialNo": "37-402",
          "deviceType": null,
          "description": "IRCHD",
          "status": "Leased",
          "locations": [
            {
              "id": "c96c417d-2a6c-4b33-bdc7-b2b94fb379ea",
              "orgID": "50e90306-c246-45f5-b7cb-88f74baab2f8",
              "activationDate": "11/9/2022 12:00:00 AM",
              "lastActiveDate": "12/9/2025 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "IRCHD2",
                "address": {
                  "id": null,
                  "address1": "1705 19th Pl Suite G3",
                  "address2": "",
                  "state": "291",
                  "city": "Vero Beach",
                  "country": "12",
                  "zipCode": "32960",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            },
            {
              "id": "3f2d6a3f-7728-45e1-9ae3-69cb06ad55f8",
              "orgID": "3e82aaf6-3237-4754-9238-c360a365a5a4",
              "activationDate": "2/6/2022 12:00:00 AM",
              "lastActiveDate": "12/31/2025 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "Headquarters_37_402",
                "address": {
                  "id": null,
                  "address1": "3930 US1",
                  "address2": "",
                  "state": "291",
                  "city": "Vero Beach",
                  "country": "12",
                  "zipCode": "32960",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "653cb3da-952b-48eb-91ae-e12ed2ea3b61",
          "name": "37-406-Takle",
          "serialNo": "37-406-Takle",
          "deviceType": null,
          "description": "Takle",
          "status": "Leased",
          "locations": [
            {
              "id": "212dcced-adb3-4753-a9cd-717907035a2b",
              "orgID": "f2150700-bd2d-4db2-89bb-b1169ee67bbe",
              "activationDate": "7/18/2022 12:00:00 AM",
              "lastActiveDate": "8/1/2080 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "37-406-Takle",
                "address": {
                  "id": null,
                  "address1": "3500 US Highway 1",
                  "address2": "",
                  "state": "291",
                  "city": "Vero Beach",
                  "country": "12",
                  "zipCode": "37406",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "1d6ecf05-c436-46c9-bed7-7b80cf0d93a2",
          "name": "3B-410",
          "serialNo": "3B-410",
          "deviceType": null,
          "description": "CAEC - B",
          "status": "Owned",
          "locations": [
            {
              "id": "6956ce85-beef-46c3-b8a2-8c1c6990d819",
              "orgID": "3e82aaf6-3237-4754-9238-c360a365a5a4",
              "activationDate": "2/6/2022 12:00:00 AM",
              "lastActiveDate": "6/30/2023 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "Headquarters_3b_410",
                "address": {
                  "id": null,
                  "address1": "3930 US 1",
                  "address2": "",
                  "state": "291",
                  "city": "Vero Beach",
                  "country": "12",
                  "zipCode": "32960",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            },
            {
              "id": "0c53eb9c-6fc9-4399-a193-126b02dedfab",
              "orgID": "3e82aaf6-3237-4754-9238-c360a365a5a4",
              "activationDate": "8/29/2022 12:00:00 AM",
              "lastActiveDate": "12/30/2022 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "Caec_Headquarters_3b_410",
                "address": {
                  "id": null,
                  "address1": "3930 US 1",
                  "address2": "",
                  "state": "291",
                  "city": "Vero Beach",
                  "country": "12",
                  "zipCode": "32960",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "6562098f-24b9-446d-9485-4745c9d8504d",
          "name": "3B-410",
          "serialNo": "3B-410",
          "deviceType": null,
          "description": "Mobile Unit",
          "status": "",
          "locations": []
        },
        {
          "id": "e3012a47-c97d-4581-a317-b11aa29c3029",
          "name": "3B-410-WFH",
          "serialNo": "3B-410",
          "deviceType": null,
          "description": "WFH",
          "status": "Leased",
          "locations": [
            {
              "id": "d90e1d58-3f66-4e20-b211-a70d2fa80fc6",
              "orgID": "49b0dddb-1715-4ce7-a97c-bd8a3c39e9de",
              "activationDate": "2/22/2022 12:00:00 AM",
              "lastActiveDate": "3/1/2035 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "WFH-Site1",
                "address": {
                  "id": null,
                  "address1": "981 37th Place",
                  "address2": "",
                  "state": "291",
                  "city": "Vero Beach",
                  "country": "12",
                  "zipCode": "32960",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "d1277185-caf7-4c09-8f6a-275db37f9f52",
          "name": "Braves",
          "serialNo": "Braves",
          "deviceType": null,
          "description": "Braves",
          "status": "Owned",
          "locations": [
            {
              "id": "f628b75c-1336-43b0-a43c-44b890d35783",
              "orgID": "1443b0f0-410e-4508-be2d-66adee3e43a0",
              "activationDate": "2/15/2023 12:00:00 AM",
              "lastActiveDate": "2/16/2029 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "Braves",
                "address": {
                  "id": null,
                  "address1": "18800 W Villages Pkwy",
                  "address2": "",
                  "state": "291",
                  "city": "Venice",
                  "country": "12",
                  "zipCode": "34293",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "128d46f4-28d7-41b4-bf63-6ac310b9acf4",
          "name": "Event",
          "serialNo": "Event-001",
          "deviceType": null,
          "description": "Event",
          "status": "Owned",
          "locations": [
            {
              "id": "1e1e547e-e2a4-4891-b253-182cf2aa1aa3",
              "orgID": "ab35a904-6be4-49b9-b163-4d470c4c5785",
              "activationDate": "2/2/2025 12:00:00 AM",
              "lastActiveDate": "2/2/2030 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "EVENT",
                "address": {
                  "id": null,
                  "address1": "Event",
                  "address2": "",
                  "state": "291",
                  "city": "Vero Beach",
                  "country": "12",
                  "zipCode": "32960",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "5c8c096e-1da7-4c2d-912b-ebbd6bfc6911",
          "name": "FFVC",
          "serialNo": "FFVC1",
          "deviceType": null,
          "description": "FFVC",
          "status": "Owned",
          "locations": [
            {
              "id": "01d5327d-c186-4a85-a79c-1e6b024d0a75",
              "orgID": "912a39ed-eac6-4f13-8790-cb32e4c62dde",
              "activationDate": "8/28/2024 12:00:00 AM",
              "lastActiveDate": "8/28/2035 12:00:00 AM",
              "location": {
                "id": null,
                "locationName": "FFVC1",
                "address": {
                  "id": null,
                  "address1": "4680 Parkway Dr",
                  "address2": "",
                  "state": "317",
                  "city": "Mason",
                  "country": "12",
                  "zipCode": "45050",
                  "addressType": 0,
                  "latitude": null,
                  "longitute": null
                }
              }
            }
          ]
        },
        {
          "id": "9cdb605e-f1bb-4b5e-96c6-552fe56758df",
          "name": "Test",
          "serialNo": "test1",
          "deviceType": null,
          "description": "Test1",
          "status": "",
          "locations": []
        }
      ]};
      commit("setDevices", response.data)
      commit("setTotalDevices", response.data.length)

      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
